t = require('views/internal/teacup-with-helpers')('member_boards_list_ad')

module.exports = ->
  t.text t.mustacheVar('copyHtml')
  t.icon 'close', { class: 'dark-hover ad-close js-close-ad', href: '#' }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/member_boards_list_ad.coffee